import firebase from '@/modules/firebase'

function getRef (path: string) {
  return firebase.default.database().ref().child(path)
}

const searchCarRef = getRef('logs/searchCar')

/** 取得 ip 等資訊 */
async function getTrace (): Promise<Record<string, string> | null> {
  try {
    const res = await fetch('https://www.cloudflare.com/cdn-cgi/trace')
    const list = (await res.text()).split('\n')

    return list
      .map((i) => {
        const [key, value] = i.split('=')
        return { key, value }
      })
      .reduce((o, i) => ({ ...o, [i.key]: i.value }), {})
  } catch (error) {
    return null
  }
}

/** 取得瀏覽器資訊 */
async function getBrowserInfo () {
  const { host, href: url } = window.location
  const { referrer, title, cookie } = document
  const { ip = null, loc: location = null, uag: userAgent = null } = { ...await getTrace() }
  const isNuxt = true

  return { host, url, title, referrer, cookie, ip, location, userAgent, isNuxt }
}

/** 插入一筆錯誤記錄 */
export async function pushErrorLog () {
  const ref = getRef('logs/error')

  const browserInfo = await getBrowserInfo()
  const timestamp = firebase.default.database.ServerValue.TIMESTAMP
  const log = { ...browserInfo, timestamp }

  return ref.push().set(log)
}

/** 插入一筆找車記錄 */
export async function pushSearchCarLog ({ userDetail, count, duration }: {
  userDetail: object | undefined,
  count: number,
  duration: number,
}) {
  const ref = searchCarRef

  const browserInfo = await getBrowserInfo()
  const timestamp = firebase.default.database.ServerValue.TIMESTAMP
  const log = { ...userDetail, ...browserInfo, timestamp, count, duration }

  const newLogRef = ref.push()
  const { key } = newLogRef // 本次新增 log 的鍵
  await newLogRef.set(log)

  return key
}

/** 插入綁卡紀錄 */
export async function pushCardLog ({ userDetail, success = true, duration, price = 0, message = '' }: {
  userDetail: object,
  success: boolean,
  duration: number,
  price?: number,
  message?: string
}) {
  const ref = getRef('logs/card')

  const browserInfo = await getBrowserInfo()
  const timestamp = firebase.default.database.ServerValue.TIMESTAMP
  const log = { ...userDetail, ...browserInfo, timestamp, duration, price, message, success }

  const newLogRef = ref.push()
  const { key } = newLogRef // 本次新增 log 的鍵
  await newLogRef.set(log)

  return key
}

export type ClickedCar = { id: number, price: number }

/** 更新每筆 Log 所點擊的車輛列表 */
export function updateLogClickedCars (
  key: string,
  list: ClickedCar[]
) {
  const ref = searchCarRef.child(`${key}/cars`)
  return ref.set(list)
}
